import { observer } from 'mobx-react-lite'
import { TextInputContainer } from '@/components/inputs/TextInputContainer'
import { useFeatures } from '@/contexts/root-store-context'
import { NewLegendDialog } from '@/features/legends/NewLegendDialog'
import type { NewLegendDialogViewModel } from './NewLegendDialogViewModel'

const testId = 'new-legend-dialog'

export interface NewLegendDialogContainerProps {
  vm: NewLegendDialogViewModel
}

export const NewLegendDialogContainer = observer(
  function NewLegendDialogContainer({ vm }: NewLegendDialogContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))
    return (
      <NewLegendDialog
        showing={vm.modal.showing}
        corporateMode={shellInfo.corporateMode}
        isPending={vm.create.pending}
        canCreate={vm.canCreate}
        onClose={vm.modal.close}
        onSubmit={vm.create}
        testId={testId}
      >
        <TextInputContainer
          autoFocus
          label="Name"
          placeholder="Legend name"
          model={vm}
          field="name"
          error={vm.validation.getError('name')}
          isDisabled={vm.create.pending}
          data-test={`${testId}-name-input`}
        />
      </NewLegendDialog>
    )
  },
)
